import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/content/svg/motomundi.svg")